import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../assets/styles/ContactThanks.module.scss';
import { motion } from 'framer-motion';
import { useScrollToTop } from '../hooks/useScrollToTop';

const ContactThanks: React.FC = () => {
  useScrollToTop();
  const navigate = useNavigate();

  return (
    <div className={styles.containerWrap}>
      <header className={styles.header}>
        <div className={styles.logoArea} onClick={() => navigate('/')}>
          <img src="/images/logo_aibex_line_b.svg" alt="Aibex" className={styles.logo} />
          <span className={styles.logoKatakana}>マーケティングに特化したAIエージェント「Aibex（アイベックス）」</span>
        </div>
      </header>

      <div className={styles.backgroundGlow}>
        <div className={styles.glowBlue} />
        <div className={styles.glowPink} />
      </div>

      <main className={styles.main}>
        <motion.div
          className={styles.messageArea}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1>お問い合わせありがとうございます</h1>
          <p>
            お問い合わせ内容を受け付けました。<br />
            担当者より折り返しご連絡いたしますので、今しばらくお待ちください。<br />
            <br />
            <span className={styles.note}>※自動返信メールが届かない場合は、入力されたメールアドレスに誤りがある可能性があります。</span>
          </p>

          <button className={styles.backBtn} onClick={() => navigate('/')}>
            トップページへ戻る
          </button>
        </motion.div>
      </main>

      <footer className={styles.footer}>
        <img src="/images/logo_aibex_line_b.svg" alt="Aibex" className={styles.footerLogo} />
        <div className={styles.footerLinks}>
          <a href="https://inovis.co.jp" target="_blank" rel="noopener noreferrer">運営会社</a>
          <span onClick={() => navigate('/privacy-policy')}>プライバシーポリシー</span>
          <span onClick={() => navigate('/terms')}>利用規約</span>
        </div>
        <p className={styles.copyright}>&copy; 2026 Inovis Inc. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default ContactThanks;
